// Mock data for LAURA GONZALEZ Artistry portfolio

export const mockData = {
  brand: {
    name: 'LAURA GONZALEZ',
    tagline: 'HAIR & MAKEUP ARTIST',
    hero: 'Artistry tailored to your essence. From effortless radiance to bold sophistication, creating timeless looks that celebrate your authentic beauty.',
    location: 'NYC & NJ'
  },
  
  journey: {
    title: 'The Journey.',
    content: 'Born and raised in Colombia and now based in New York, I am a makeup artist dedicated to minimal, detail-driven beauty and refined skin. I made the life-changing decision to leave my career in Industrial Engineering to fully commit to my true passion and lifelong dream of becoming a professional makeup artist. My approach is centered on enhancing each person\'s authentic beauty through clean, timeless finishes with a modern edge. For me, makeup is more than a service; it\'s a mindful, calm process of making every person feel beautiful, seen, and effortlessly elevated.'
  },
  
  // Professional headshot photos for About section
  headshots: {
    photo1: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/dkfbp44n_Portrait%2002-07-2026-439.jpg', // ACTUAL - Portrait 02-07-2026-439
    photo2: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/0qozadbg_Portrait%2002-07-2026-461.jpg', // ACTUAL - Portrait 02-07-2026-461
    actionShot: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/gaachwii_Portrait%2002-07-2026-258.jpg' // ACTUAL - Portrait 02-07-2026-258
  },
  
  services: [
    {
      id: 1,
      title: 'Editorial & Commercial',
      description: 'High-performance artistry for photography and media.',
      features: []
    },
    {
      id: 2,
      title: 'Bespoke Bridal Services',
      description: 'A curated, on-site luxury experience for the modern bride.',
      features: []
    }
  ],
  
  portfolio: {
    editorial: [
      {
        id: 1,
        title: 'Editorial Look 1',
        category: 'Editorial Artistry',
        image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/ts9o2o92_C30A0791.jpg', // ACTUAL IMAGE - Model in black (moved from hero)
        orientation: 'portrait'
      },
      {
        id: 2,
        title: 'Editorial Look 2',
        category: 'Editorial Artistry',
        image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/o7xfchgn_DSC01896.JPG', // ACTUAL IMAGE
        orientation: 'portrait'
      },
      {
        id: 3,
        title: 'Editorial Look 3',
        category: 'Editorial Artistry',
        image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/13vemnia_DSC03807.JPEG', // ACTUAL IMAGE
        orientation: 'landscape'
      },
      {
        id: 4,
        title: 'Editorial Look 4',
        category: 'Editorial Artistry',
        image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/ebhrs5f8_IMG_6295%20%281%29.jpg', // ACTUAL IMAGE - NEW
        orientation: 'portrait'
      },
      {
        id: 5,
        title: 'Editorial Look 5',
        category: 'Editorial Artistry',
        image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/phb2shhk_DSC01800.JPG', // ACTUAL IMAGE - moved to end
        orientation: 'landscape'
      },
      {
        id: 6,
        title: 'Editorial Look 6',
        category: 'Editorial Artistry',
        image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/osjuwbnq_DSC01801.JPG', // ACTUAL IMAGE - moved to end
        orientation: 'portrait'
      }
    ],
    bridal: [
      {
        id: 7,
        title: 'Bridal Look 1',
        category: 'Bespoke Bridal',
        image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/5yy95k0g_Photo%20Jan%2003%202026%2C%2011%2059%2018%20AM.jpg', // ACTUAL IMAGE
        orientation: 'portrait'
      },
      {
        id: 8,
        title: 'Bridal Look 2',
        category: 'Bespoke Bridal',
        image: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/us4ng8ci_Photo%20Mar%2010%202026%2C%209%2052%2005%20PM.jpg', // ACTUAL IMAGE
        orientation: 'landscape'
      },
      {
        id: 9,
        title: 'Bridal Look 3',
        category: 'Bespoke Bridal',
        image: '/bridal_frame.jpg', // EXTRACTED FROM VIDEO
        orientation: 'portrait'
      }
    ],
    categoryDescriptions: {
      editorial: 'Bold, creative, fashion-forward artistry',
      bridal: 'Luminous, timeless, authentically you'
    }
  },
  
  // Hero image
  heroImage: 'https://customer-assets.emergentagent.com/job_glam-studio-nyc/artifacts/acwc7cn2_C30A0203.jpg', // ACTUAL - C30A0203.jpg (editorial with flower)
  
  contact: {
    email: 'laugonzalez.mua@gmail.com',
    instagram: '@laugonzalez.mua',
    instagramUrl: 'https://www.instagram.com/laugonzalez.mua?igsh=YmJ3eW1pcnZtd3V5&utm_source=qr',
    tallyForm: 'https://tally.so/r/PdlXM5'
  }
};
